import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getTourQueryOptions, getToursQueryOptions } from "./get.hooks";

export function useDeleteTour(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/tours/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getToursQueryOptions.queryKey, (old) =>
        old?.filter((t) => t.id !== id),
      );
      queryClient.resetQueries({ queryKey: getTourQueryOptions(id).queryKey });
      toast({
        title: "toast.tourDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteTourError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
